import React, { Component } from 'react';
import { Modal, Spin, message } from 'antd';
import {
    SortableContainer,
    SortableElement,
    arrayMove,
} from "react-sortable-hoc";
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';

let type = 'CASH_REQ';

const SortableItem = SortableElement(({ item, disabled }) => {
    return (
        <div className="sortgrid-item">
            <div className={`sortitem ${item.isDefault == 1 ? 'disabled' : ''}`} title={item.title}>
                {item.title}
            </div>
        </div>
    );
});

const SortableList = SortableContainer(({ list }) => {
    return (
        <div className="degreesort">
            {list.map((item, index) =>
                <SortableItem
                    key={`item-${index}`}
                    index={index}
                    item={item}
                    disabled={item.isDefault == 1}
                />
            )}
        </div>
    );
});

class SortList extends Component {
    state = {
        data: [],
        visible: false,
        loading: false,
    }

    loadData = () => {
        this.setState({ loading: true });
        Fetch.post(API_URL.common.queryUserCustomDisplayByUserId, {
            type
        }).then(res => {
            const data = res[type] || [];
            this.setState({
                data,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    show = (key) => {
        type = key;
        this.setState({
            data: [],
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    onSortEnd = ({ oldIndex, newIndex }) => {
        const { data } = this.state;
        this.setState({ data: arrayMove(data, oldIndex, newIndex) })
    }

    submit = () => {
        const { data } = this.state;

        const params = {};
        data.forEach((item, index) => {
            const { isShow, userCustomDisplayDefineId } = item;
            params[`customDisplayDefines[${index}].userCustomDisplayDefineId`] = userCustomDisplayDefineId;
            params[`customDisplayDefines[${index}].isShow`] = isShow;
            params[`customDisplayDefines[${index}].sortIndex`] = index;
        });

        this.setState({ loading: true });
        Fetch.post(API_URL.common.saveUserCustomDisplaySort, {
            ...params,
            type
        }).then(res => {
            message.success(res.success);
            this.setState({ loading: false }, () => {
                this.hide();
                this.props.loadData();
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    render() {
        const { data, visible, loading } = this.state;
        const title = (type === 'CASH_REQ_MULTI_CONTRACT' && '合同') || '请款';
        return (
            <Modal
                title={`${title}字段排序`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="sort-modal"
                confirmLoading={loading}
                bodyStyle={{ maxHeight: 500 }}
                maskClosable={false}
                width="932px"
            >
                <Spin spinning={loading}>
                    <SortableList
                        list={data}
                        distance={10}
                        axis="xy"
                        helperClass="sortHelper"
                        onSortEnd={this.onSortEnd}
                    />
                </Spin>
            </Modal>
        );
    }
}

export default SortList;



// WEBPACK FOOTER //
// ./src/components/contractManagement/requestRecord/components/SortList.js